import { render, staticRenderFns } from "./ConsensiStruttureListModalComponent.vue?vue&type=template&id=00267928&scoped=true"
import script from "./ConsensiStruttureListModalComponent.vue?vue&type=script&lang=js"
export * from "./ConsensiStruttureListModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsensiStruttureListModalComponent.vue?vue&type=style&index=0&id=00267928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00267928",
  null
  
)

export default component.exports